import { render, staticRenderFns } from "./ModalRedeemPoint.vue?vue&type=template&id=99b78146&scoped=true"
import script from "./ModalRedeemPoint.vue?vue&type=script&lang=js"
export * from "./ModalRedeemPoint.vue?vue&type=script&lang=js"
import style0 from "./ModalRedeemPoint.vue?vue&type=style&index=0&id=99b78146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b78146",
  null
  
)

export default component.exports